import { useEffect, useState } from "react";
import Form from "./settings components/Form";
import { Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";

export default function PermissionSettings({
  editState,
  setEditState,
  platformID,
}) {
  const axios = useAxios();
  const { loader } = useComponent();

  const [formData, setFormData] = useState({});
  const [settings, setSettings] = useState([]);

  useEffect(() => {
    let settingUrl = "/get/displaySettings?platform_id=" + platformID;
    if (platformID === "Verismart") {
      settingUrl = "/get/displaySettings";
    }

    axios({
      url: settingUrl,
      method: "GET",
    }).then((response) => {
      if (response.status) {
        setSettings(response.data);
        for (let setting of response.data) {
          setFormData((prev) => ({
            ...prev,
            [setting.setting_key]: setting.setting_flag,
          }));
        }
        loader.stop();
      }
    });
  }, [axios, loader, platformID]);

  return (
    <Loader>
      <Form
        platformID={platformID}
        editState={editState}
        setEditState={setEditState}
        settings={settings}
        formData={formData}
        setFormData={setFormData}
      />
    </Loader>
  );
}
